import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";

class Faq extends Component {
    state = {
    }

    componentDidMount() {
        var path = window.location.pathname
        path = path.slice(1, 3);
        if (path === 'en') {
          require("./faq.css");
        } else if (path === 'sc') {
          require("./faq_sc.css");
        } else if (path === 'tc') {
          require("./faq_sc.css");
        }
    }
    render() {
        const { t } = this.props;
        return (
            <div className="d-flex justify-content-center">
                <MetaTags>
                    <title>{t('faq-meta-title')}</title>
                    <meta name="title" content={t('faq-meta-title')} />
                    <meta name="description" content={t('faq-meta-description')} />
                    <meta name="keywords" content={t('faq-meta-keywords')} />
                </MetaTags>
                <div id="div-faq">
                    <div className="faq-header">
                        <div className="container-fluid d-flex justify-content-center">
                            <div className="col-12 col-md-10">
                                <div className={t('faq-header-text TXT_medium')}>{t('faq-title')}</div>
                            </div>
                        </div>
                    </div>
                    <div className="faq-content">
                        <div className="container-fluid d-flex justify-content-center">
                            <div className="col-12 col-md-10">
                            <div className={t('faq-content-headline TXT_bold')}>{t('faq-headline-1')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-1')}</div>
                            <div className="faq-content-answer">{t('faq-answer-1-1')}<span className={t('TXT_bold')}>{t('faq-answer-1-2')}</span>{t('faq-answer-1-3')}</div>
                            <div className={t('faq-content-headline TXT_bold')}>{t('faq-headline-2')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-2')}</div>
                            <div className="faq-content-answer">{t('faq-answer-2')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-3')}</div>
                            <div className="faq-content-answer">{t('faq-answer-3')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-4')}</div>
                            <div className="faq-content-answer">{t('faq-answer-4')}</div>
                            <div className={t('faq-content-headline TXT_bold')}>{t('faq-headline-3')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-5')}</div>
                            <div className="faq-content-answer">{t('faq-answer-5')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-6')}</div>
                            <div className="faq-content-answer">{t('faq-answer-6')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-7')}</div>
                            <div className="faq-content-answer">{t('faq-answer-7')}</div>
                            <div className={t('faq-content-headline TXT_bold')}>{t('faq-headline-4')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-8')}</div>
                            <div className="faq-content-answer">{t('faq-answer-8')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-9')}</div>
                            <div className="faq-content-answer">{t('faq-answer-9')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-10')}</div>
                            <div className="faq-content-answer">{t('faq-answer-10')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-11')}</div>
                            <div className="faq-content-answer">{t('faq-answer-11')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-12')}</div>
                            <div className="faq-content-answer">{t('faq-answer-12')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-13')}</div>
                            <div className="faq-content-answer">{t('faq-answer-13')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-14')}</div>
                            <div className="faq-content-answer">{t('faq-answer-14')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-15')}</div>
                            <div className="faq-content-answer">{t('faq-answer-15')}</div>
                            <div className={t('faq-content-question TXT_bold')}>{t('faq-question-16')}</div>
                            <div className="faq-content-answer">{t('faq-answer-16')}</div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div >



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Faq);



// WEBPACK FOOTER //
// ./src/components/pages/faq.js